import { DataBean } from "../DataBean";


export class TaxSchemeValueArticleType extends DataBean {

    public async getTaxSchemeValueArticleTypeCatalog(idTaxSchemeValue: number): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getTaxSchemeValueArticleTypeCatalog_Number", [idTaxSchemeValue]);
    }

    public async addArticleTypeToTaxSchemeValue(idTaxSchemeValue: number, adquisitionArticleType: number): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.quickdataerp.bean.admin.TaxSchemeValueArticleType_addArticleTypeToTaxSchemeValue_Number_Number", [idTaxSchemeValue, adquisitionArticleType]);
    }

    public async updateTaxSchemeValueArticleType(bean: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.quickdataerp.bean.admin.TaxSchemeValueArticleType_updateTaxSchemeValueArticleType_com.quickdataerp.bean.admin.TaxSchemeValueArticleType", [
            {
                "DataBeanProperties": bean,
                "DataBeanName": "com.quickdataerp.bean.admin.TaxSchemeValueArticleType"
            }
        ]);
    }

    public async deleteTaxSchemeValueArticleType(idTaxSchemeValueArticleType: number): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "void_deleteTaxSchemeValueArticleType_Number", [idTaxSchemeValueArticleType]);
    }

}